import './PopUp.css'

interface PopUpProps {
    msg: string,
    setShowMsg: React.Dispatch<React.SetStateAction<boolean>>,
    showMsg: boolean,
    msgStyling?: string
    showCloseButton?: boolean
}

const PopUp = (props: PopUpProps) => {
    return (
        <div className={props.showMsg ? "modal" : "hide"}>
            <div className="modal-content">
                {props.showCloseButton && (
                    <span className="close" onClick={() => props.setShowMsg(false)}>&times;</span>
                )}
                <p className={props.msgStyling}>{props.msg}</p>
            </div>
        </div>
    )
}

export default PopUp;